import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Card, Container, Row, Col, Form, FormLabel, Accordion, InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';


export default function MPTH_customer_offices({ entity, data, searchObj, setSearchObj }) {


    function createNewAddress() {
        if (localStorage.getItem('idCustomer')) {
            window.open('/entity/customer/edit?id=' + parseInt(localStorage.getItem('idCustomer')), '_blank')
        } else {
            toast.error('Selezionare prima un cliente', { theme: 'colored' })
        }
    }



    return (
        <>
            <Button variant='outline-primary' size='sm' className='my-1' onClick={() => createNewAddress()}>Aggiungi sede</Button>
        </>
    )
};